module.exports = __webpack_public_path__ + "img/clap.fbcc8f78.svg";